import { useState } from 'react';
import { Loader } from '../../components';
import { downloadBillingReport } from '../../api/billingApi';
import { showToast } from '../../services/toast.service';
import { BILLING_CONSTANTS, LABEL_CONSTANTS } from '../../constants/common';
import { toastMessages } from '../../constants/errorMessages';

const Billing = () => {
  const [downloadingReport, setDownloadingReport] = useState(false);

  const handleDownloadReport = async () => {
    if (downloadingReport) return;
    try {
      setDownloadingReport(true);
      const response = await downloadBillingReport();
      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const now = new Date();
      const localDateTime = now
        .toLocaleString()
        .replace(/[/:, ]+/g, '-')
        .replace(/-+/g, '-');
      link.download = `Monthly_Billing_Report_${localDateTime}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error('Failed to download billing report', error);
      showToast.error(toastMessages.FAILED_TO_DOWNLOAD_REPORT);
    } finally {
      setDownloadingReport(false);
    }
  };

  return (
    <>
      <p className="tab-guide billing-subheader">{BILLING_CONSTANTS.BILLING_SUBHEADER_LINE_1}</p>
      <p className="tab-guide billing-subheader">{BILLING_CONSTANTS.BILLING_SUBHEADER_LINE_2}</p>
      <div className="billing-section">
        <div className="submit-button">
          <div className="billing-section">
            <div className="submit-button">
              {downloadingReport ? (
                <div className="download-loader">
                  <Loader loaderSize="medium" />
                </div>
              ) : (
                <button className="button green" onClick={handleDownloadReport}>
                  {LABEL_CONSTANTS.DOWNLOAD}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Billing;
